import { render, staticRenderFns } from "./LogoFallback.vue?vue&type=template&id=3ce19af9&scoped=true&"
import script from "./LogoFallback.vue?vue&type=script&lang=ts&"
export * from "./LogoFallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce19af9",
  null
  
)

export default component.exports